import { render, staticRenderFns } from "./shipper_select.vue?vue&type=template&id=a782f56a&"
import script from "./shipper_select.vue?vue&type=script&lang=js&"
export * from "./shipper_select.vue?vue&type=script&lang=js&"
import style0 from "./shipper_select.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports